import ImageWithFallback from '@/Component/Common/ImageWithFallback';

const InfluencerInfo = (props) => {
    const { data, userDetails } = props;
    return (
        <div className="rounded-xl overflow-hidden bg-gray/10">
            <div className='md:py-6 py-5 px-5 bg-gradient-to-br from-secondary to-primary flex md:items-center justify-between max-md:flex-col max-md:gap-5'>
                <div className='flex items-center 2xl:gap-5 gap-3 text-white'>
                    <div className='2xl:min-w-[70px] min-w-14 2xl:w-[70px] 2xl:h-[70px] w-14 h-14 rounded-full overflow-hidden bg-gray'>
                        <ImageWithFallback src={data?.image} alt='Profile' className='w-full h-full object-cover' height={70} width={70} />
                    </div>
                    <div className='flex flex-col gap-1.5'>
                        <h5 className='font-semibold 2xl:text-xl text-lg leading-7 text-white'>{data?.first_name} {data?.last_name} ({data?.display_name})</h5>
                        {data?.country && <span className='2xl:text-lg text-base leading-6'>{data?.country}</span>}
                    </div>
                </div>
            </div>
            <div className='flex items-center lg:gap-16 gap-8 2xl:my-10 my-5 px-5'>
                <div className='flex flex-col gap-0.5'>
                    <h6 className='font-semibold md:text-lg text-base leading-5'>{data?.total_followers}</h6>
                    <span className='md:text-sm text-xs'>Followers</span>
                </div>
                <div className='flex flex-col gap-0.5'>
                    <h6 className='font-semibold md:text-lg text-base leading-5'>{data?.engagement_ratio == '0.00' ? '--' : Number(data?.engagement_ratio).toFixed(1)} %</h6>
                    <span className='md:text-sm text-xs'>Engagement Rate</span>
                </div>
            </div>
            <div className="px-5">
                <h6 className='font-semibold md:text-lg text-base leading-5'>About</h6>
                <p className='text-sm'>{data?.about_me ? data?.about_me : '-'}</p>
            </div>
        </div>
    )
}

export default InfluencerInfo
